import { boardFileSchema } from '@/backend/features/board-files/shared/BoardFile';
import { boardTypeSchema } from '@/backend/features/board-files/shared/BoardType';
import { defineColumns, EntityColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';

export const boardEntityName = 'board';

export type BoardData = z.infer<typeof boardDataSchema>;
export const boardDataSchema = z.object({
    board: z.string(),
    industry: z.string().optional(),
    type: boardTypeSchema.optional(),
    descriptionHtml: z.string(),
    files: z.array(boardFileSchema),
});

export type BoardColumns = EntityColumns<typeof boardColumnsDef>;
export const boardColumnsDef = defineColumns({
    board: {
        type: 'string-required',
        index: 'partial',
    },
    industry: {
        type: 'string',
        index: 'partial',
    },
    type: {
        type: 'string',
    },
    descriptionHtml: {
        type: 'string-required',
    },
    attachmentKeys: {
        type: 'string-array-required',
    },
    fileNames: {
        type: 'string-array-required',
    },
});
